<template lang="pug">
  .companion
    .debug-code {{ debugString }}
    .companion-row(:class="{ active: isOffline }")
      .companion-content
        .companion-title Você está offline
        .companion-text Seus dados serão sincronizados quando houver conexão
      i.companion-icon.material-icons wifi_off
    template(v-if="telemetry.last")
      .companion-row(:class="{ active: isIncompatible }")
        .companion-content
          .companion-title Seu navegador é incompatível
          .companion-text Por favor, instale a aplicação através do Google Chrome
        i.companion-icon.material-icons info_outline
      .companion-row(:class="{ active: !isOffline && !updated }")
        .companion-content
          .companion-title Atualização disponível
          .companion-text Há uma nova versão do aplicativo.
            .companion-button(@click="reload") Baixar
        i.companion-icon.material-icons update
      template(v-if="showGps")
        .companion-row(:class="{ active: isCoachingRoute && gpsImcompatible }")
          .companion-content
            .companion-title Dispositivo incompatível
            .companion-text O seu dispositivo não possui suporte a Geolocalização, por favor, utilize um aparelho compatível
          i.companion-icon.material-icons location_off
        .companion-row(:class="{ active: isCoachingRoute && gpsDenied }")
          .companion-content
            .companion-title Acesso ao GPS negado
            .companion-text O acesso a geolocalização do dispositivo foi negado,&nbsp;
              nuxt-link(to="ajuda/gps-negado") clique aqui
              | &nbsp;e saiba como corrigir
          i.companion-icon.material-icons location_off
        .companion-row(:class="{ active: isCoachingRoute && gpsUnavailable }")
          .companion-content
            .companion-title GPS Indisponível
            .companion-text Busque uma região aberta para obter um sinal melhor de GPS
          i.companion-icon.material-icons wrong_location
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'OfflineCompanion',
  computed: {
    ...mapState({
      offline: state => state.offline.isOffline,
      device: state => state.telemetry.device,
      user: state => state.auth.user,
      telemetry: state => state.telemetry,
    }),
    ...mapGetters('version', ['updated']),
    isOffline() {
      return this.offline && !navigator.onLine
    },
    debugString() {
      let logged = 0
      let employeeCode = null
      if (this.user) {
        logged = 1
        employeeCode = this.user.employeeCode
      }
      return [
        [
          this.telemetry.last ? 0 : 1,
          this.ifOffline ? 1 : 0,
          this.isIncompatible ? 1 : 0,
          !this.updated ? 1 : 0,
          this.gpsIncompatible ? 1 : 0,
          this.gpsUnavailable ? 1 : 0,
          this.gpsDenied ? 1 : 0,
          this.telemetry.running ? 1 : 0,
          logged,
        ].join(''),
        this.telemetry.entries.length,
        employeeCode,
      ]
        .filter(v => v !== null)
        .join('.')
    },
    isIncompatible() {
      return !this.device?.client?.name?.includes('Chrome')
    },
    showGps() {
      return !this.$store.state.auth?.user?.teleSales
    },
    isCoachingRoute() {
      return this.$route.path.startsWith('/coaching')
    },
    gpsImcompatible() {
      return this.telemetry.last?.geolocation?.statusCode === -1
    },
    gpsUnavailable() {
      return this.telemetry.last?.geolocation?.statusCode === 2
    },
    gpsDenied() {
      return this.telemetry.last?.geolocation?.statusCode === 1
    },
  },
  methods: {
    reload() {
      this.$store.commit('version/setUpdate')
      window.location.reload(true)
    },
  },
}
</script>

<style lang="sass">
.companion
  position: fixed
  top: 8px
  right: 16px
  display: flex
  flex-flow: column
  align-items: flex-end
  justify-content: center
  z-index: 99999
  &-row
    transition: all .5s
    visibility: visible
    opacity: 1
    display: flex
    align-items: center
    justify-content: center
    &:not(.active)
      opacity: 0
      visibility: hidden
      position: absolute
  &-content
    background: white
    margin-right: 8px
    transition: all .5s
    text-align: right
    padding: 8px
    border: 1px solid rgba(0, 0, 0, .33)
      radius: 8px
  &-row:not(:active):not(:hover) &-content
    opacity: 0
    visibility: hidden
    transform: translate(5%)
  &-title
    font-weight: bold
    color: red
    padding-bottom: 4px
  &-text
    font-size: .8em
  &-button
    background: red
    color: white
    margin: 8px
    padding: 8px
    display: inline-block
    border-radius: 8px
  &-icon
    color: red
    font-size: 48px
    text-shadow: 0px 0px 8px white
.debug-code
    position: fixed !important
    top: 0px !important
    left: 6px !important
    font-size: 10px !important
    font-family: monospace !important
    color: #222 !important
    text-shadow: 1px 1px 1px #DDD !important
    opacity: .5 !important
    user-select: none !important
    pointer-events: none !important
    text-align: right !important
    z-index: 99999 !important
</style>
